import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const EmpleadosView = lazy(() => import('../../container/administracion/empleados/Index'));
const EmpleadosForm = lazy(() => import('../../container/administracion/empleados/Form'));
const EmpleadoFiles = lazy(() => import('../../container/administracion/empleados/Files'));
const EmpleadoComisionView = lazy(() => import('../../container/administracion/empleados/Comision'));

const EmpleadosRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/recursos-humanos/listado`} component={EmpleadosView} />
       <Route path={`${path}/recursos-humanos/agregar`} component={EmpleadosForm} />
       <Route exact path={`${path}/recursos-humanos/editar/:id`} component={EmpleadosForm} />
       <Route exact path={`${path}/recursos-humanos/expediente/:id`} component={EmpleadoFiles} />
       <Route exact path={`${path}/recursos-humanos/comision/:id`} component={EmpleadoComisionView} />
    </Switch>
  );
};

export default EmpleadosRoute;
